<template>
  <ul class="flex flex-wrap rounded grid lg:grid-cols-3 gap-4">
    <li v-for="post in posts" :key="post.id">
      <router-link :to="{ name: 'PostDetails', params: { id: post.id } }">
        <figure class="md:flex rounded-lg bg-white dark:bg-gray-800 md:p-0">
          <div class="p-3">
            <h3 class="text-cyan-600 text-lg">{{ post.title }}</h3>
            <p class="mt-3">{{ post.chapters.length }} chapters</p>
            <p class="text-gray-400 text-sm italic" v-for="tag in post.tags" :key="tag">#{{ tag }}</p>
            <h4 class="text-gray-400 text-sm mb-1">author Mr / Ms {{ post.userName }}</h4>
          </div>
        </figure>
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  props: ["posts"],
}
</script>
